
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"23","height":"24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_3606_184021)","fill":"#0D69D5"}},[_c('path',{attrs:{"d":"M18.205 11.99c-.53 0-.958.448-.958 1v8.006c0 .551-.43 1-.958 1H2.875c-.53 0-.958-.449-.958-1V6.986c0-.55.428-1 .958-1h7.665c.53 0 .958-.449.958-1 0-.553-.428-1.002-.958-1.002H2.875C1.29 3.984 0 5.331 0 6.986v14.01c0 1.655 1.29 3.002 2.875 3.002h13.414c1.585 0 2.875-1.347 2.875-3.002v-8.005c0-.554-.429-1.001-.959-1.001zM21.884 4.434l.595-.631c.728-.76.677-2.045-.052-2.806l-.382-.399c-.729-.76-1.958-.814-2.687-.054l-.604.62 3.13 3.27z"}}),_c('path',{attrs:{"d":"M8.619 11.772l-.026.027-1.875 5.034c-.046.124.073.248.197.205l4.809-1.97 9.691-10.121-3.136-3.275-9.665 10.095.005.005zm-.827 3.107l.95-2.535c.032.13.094.248.186.345a.742.742 0 00.63.216l.14-.016-.015.145c-.021.26.051.496.212.664.16.167.377.242.63.216l.139-.016-.015.145a.816.816 0 00.206.658.761.761 0 00.362.205l-2.443.998-.982-1.024zM18.6 4.414l.139.145-7.351 7.678-.14-.146L18.6 4.413z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_3606_184021"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h23v24H0z"}})])])])
          )
        }
      }
    